import request from "@/utils/request";

export function saveOrUpdate(data) {
    return request({
      url: "/flow/path/saveOrUpdate",
      method: "post",
      data,
    });
  }
  
  export function get(id) {
    return request({
      url: "/flow/path/get",
      method: "get",
      params: { id },
    });
  }
export function deleteById(id) {
    return request({
      url: "/flow/path/deleteById",
      method: "post",
      data: { id: id },
    });
  }
  export function getByPathTemplate(condition, pagination) {
    return request({
      url: "/flow/path/getByPathTemplate",
      method: "post",
      data: { condition: condition, pagination: pagination },
    });
  }
  export function getFlowTempInfo(category) {
    return request({
      url: '/flow/getFlowTempInfo',
      method: 'post',
      data: { category}
    })
  }
    
